import { cn } from "@/core/utils/func/cn";
import type { HTMLAttributes, PropsWithChildren } from "react";

type NoTranslateProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    as?: "div" | "section" | "main" | "span";
  }
>;

export const NoTranslate = ({
  children,
  className,
  as: Component = "div",
  ...props
}: NoTranslateProps) => (
  <Component translate="no" className={cn("notranslate", className)} {...props}>
    {children}
  </Component>
);
